import axios from 'axios'
import Vue from 'vue'

// 创建 axios 实例
const service = axios.create({
  baseURL: 'https://official.quying666.com', // 基础 API 地址
  timeout: 15000, // 请求超时时间
  withCredentials: false // 不携带 cookie
})

// 简单的消息提示
const showMessage = (message, type = 'error') => {
  // 使用 Vue 实例显示简单提示
  if (typeof window !== 'undefined' && window.console) {
    if (type === 'error') {
      console.error('❌', message)
    } else {
      console.log('ℹ️', message)
    }
  }
  
  // 如果有 UI 库可以使用，或者使用原生 alert
  // alert(message) // 如果需要简单提示可以取消注释
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    console.log('🚀 发出请求:', config.method?.toUpperCase(), config.url)
    
    // 默认 Content-Type
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json'
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('❌ 请求配置错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('✅ 收到响应:', res)
    
    // 根据后端返回的 code 判断成功与否
    // 这里假设 code 为 1 表示成功，您可以根据实际情况调整
    if (res.code === 1) {
      return res
    } else {
      // 业务逻辑错误
      const errorMsg = res.msg || res.message || '请求失败'
      showMessage(errorMsg)
      return Promise.reject(new Error(errorMsg))
    }
  },
  error => {
    console.error('❌ 响应错误:', error)
    
    let message = '网络错误，请稍后重试'
    
    if (error.response) {
      // 服务器返回错误状态码
      switch (error.response.status) {
        case 400:
          message = '请求参数错误'
          break
        case 404:
          message = '请求地址不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        case 502:
          message = '网关错误'
          break
        case 503:
          message = '服务不可用'
          break
        default:
          message = `网络错误 (${error.response.status})`
      }
    } else if (error.request) {
      // 请求发出但没有收到响应
      if (error.code === 'ECONNABORTED') {
        message = '请求超时'
      } else {
        message = '网络连接失败'
      }
    } else {
      message = error.message
    }
    
    showMessage(message)
    return Promise.reject(error)
  }
)

export default service